export default "__VITE_ASSET__ea2513ce__"